<template>
  <div class="comp-contacts">
    <h1 class="headline">CLIENTS/SUPPLIERS</h1>

    <div class="toolbar">
      <div class="btns">
        <button v-if="ftType != 'contact'" type="button" class="btn btn-outline-black w180" @click="showModalAdd = true">+ New {{ ftType | capitalize }}</button>
        <button v-else type="button" class="btn btn-outline-black w180" @click="showContactModal = true">+ New Contact</button>
      </div>

      <div class="filters">
        <div class="tabs">
          <ul>
            <li v-for="(tab, index) in tabs" :key="index">
              <a href="javascript:;" :class="{active: ftType==tab.value}" @click="ftType = tab.value">
                {{ tab.label }}
              </a>
            </li>
          </ul>
        </div>
        <div class="input-search">
          <input type="text" name="s" v-model="keyword" class="form-control" placeholder="SEARCH CONTACTS..." @change="getData">
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table v-if="ftType=='client'" class="table table-sm table-hover">
        <thead>
        <tr>
          <th>COMPANY</th>
          <th>EMAIL</th>
          <th>PHONE</th>
          <th>MANGER</th>
          <th width="100" class="text-right"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(client, index) in clients" :key="index">
          <td>
            <router-link :to="{ name: 'client', params: { itemId: client.id } }" class="black">{{ client.name }}
            </router-link>
          </td>
          <td>{{ client.email }}</td>
          <td>{{ client.phone }}</td>
          <td>{{ client.manager?client.manager.full_name:'' }}</td>
          <td align="right">
            <a href="javascript:;" class="icon-trash" v-tooltip="'Delete Client'" @click="confDelete( index )"></a>
          </td>
        </tr>
        </tbody>
      </table>

      <table v-else-if="ftType=='supplier'" class="table table-sm table-hover">
        <thead>
        <tr>
          <th>COMPANY</th>
          <th>EMAIL</th>
          <th>PHONE</th>
          <th>MANGER</th>
          <th width="100" class="text-right"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(supplier, index) in suppliers" :key="index">
          <td>
            <router-link :to="{ name: 'supplier', params: { itemId: supplier.id } }" class="black">{{ supplier.name }}
            </router-link>
          </td>
          <td>{{ supplier.email }}</td>
          <td>{{ supplier.phone }}</td>
          <td>{{ supplier.manager?supplier.manager.full_name:'' }}</td>
          <td align="right">
            <a href="javascript:;" class="icon-trash" v-tooltip="'Delete Supplier'" @click="confDelete( index )"></a>
          </td>
        </tr>
        </tbody>
      </table>

      <table v-else class="table table-sm table-hover">
        <thead>
        <tr>
          <th><a href="javascript:;">NAME</a></th>
          <th><a href="javascript:;">COMPANY</a></th>
          <th><a href="javascript:;">POSITION</a></th>
          <th><a href="javascript:;">EMAIL</a></th>
          <th width="40"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(contact, index) in contacts" :key="index">
          <td>
            <router-link :to="{name: 'client', params: {itemId: contact.client_id}}" class="black">{{ contact.full_name }}</router-link>
          </td>
          <td>{{ contact.client.name }}</td>
          <td>{{ contact.role }}</td>
          <td>
            <a :href="'mailto:' + contact.email">{{ contact.email }}</a>
          </td>
          <td class="text-right actions">
            <a href="javascript:;" class="icon-trash" v-tooltip="'Delete contact'" @click="confDeleteContact(index)"></a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <modal-add-client v-model="showModalAdd" :type="ftType" @added="onClientAdded"></modal-add-client>
    <modal-add-contact v-model="showContactModal" :clients="all" @contact-saved="onContactAdded"></modal-add-contact>
  </div>
</template>

<script>
  import ServiceClient from '@/services/client'
  import ModalAddClient from './ModalAddClient'
  import ModalAddContact from './ModalAddContact'

  export default {
    components: {
      ModalAddClient,
      ModalAddContact
    },
    data() {
      return {
        showModalAdd: false,
        showContactModal: false,
        ftType: 'client',
        tabs: [
          {value: 'client', label: 'CLIENTS'},
          {value: 'supplier', label: 'SUPPLIERS'},
          {value: 'contact', label: 'CONTACTS'},
        ],
        state: 'loading',
        keyword: '',
        activeIndex: -1,
        all: [],
        clients: [],
        suppliers: [],
        contacts: []
      }
    },
    watch: {},
    computed: {},
    mounted() {
      this.init();
    },
    methods: {
      init() {
        let self = this;
        self.showModalAdd = false;
        self.showContactModal = false;
        self.getData();
      },
      onClientAdded(client) {
        let self = this;
        self.$router.push({
          name: self.ftType,
          params: {
            itemId: client.id
          }
        });
      },
      onContactAdded(contact) {
        this.contacts.unshift(contact);
      },
      confDelete(index) {
        let self = this, item = null;
        if (self.ftType == 'client')
          item = self.clients[index];
        else if(self.ftType == 'supplier')
          item = self.suppliers[index];

        self.$dialog
          .confirm('Are you sure you want to delete ' + self.ftType + ' <strong>' + item.name + '</strong>?', {
            html: true,
            loader: true,
            okText: "Yes, I'm sure",
            cancelText: "Cancel",
          })
          .then(dialog => {
            ServiceClient.delete(item.id, () => {
              dialog.close();
              if (self.ftType == 'client')
                self.clients.splice(index, 1);
              else if(self.ftType == 'supplier')
                self.suppliers.splice(index, 1);
              self.$notify({
                type: 'success',
                text: '<strong>' + item.name + '</strong> has been deleted'
              });
            });
          })
          .catch(() => {
          })
        ;
      },
      confDeleteContact(index) {
        let self = this, item = self.contacts[index];

        self.$dialog
          .confirm('Are you sure you want to delete contact/member <strong>' + item.full_name + '</strong>?', {
            html: true,
            loader: true,
            okText: "Yes, I'm sure",
            cancelText: "Cancel",
          })
          .then(dialog => {
            ServiceClient.deleteMember(item.client_id, item.id, () => {
              dialog.close();
              self.contacts.splice(index, 1);
              self.$notify({
                type: 'success',
                text: '<strong>' + item.name + '</strong> has been deleted'
              });
            });
          })
          .catch(() => {
          })
        ;
      },
      getData() {
        let self = this,
          params = {
            ipp: 'all',
          };

        if (self.keyword !== '') {
          params.kw = self.keyword;
        }

        self.state = 'loading';
        ServiceClient.getAll(params, resp => {
          self.state = 'loaded';
          self.clients = [];
          self.suppliers = [];
          self.all = resp;
          for (let i in resp) {
            if (resp[i].is_supplier)
              self.suppliers.push(resp[i]);
            else
              self.clients.push(resp[i]);
          }
        });

        ServiceClient.getAllMembers(params, resp => {
          self.contacts = resp;
        });
      }
    }
  }
</script>
